import { useEffect, useState } from "react";
import { closeBrowserPhone, createJob, openJobQuickView } from "../../core/Global";
import { CallStateSnapshot, SipPhoneManager } from "../../core/SipPhoneManager";
import Job from "../../modules/crm/jobs/models/Job";
import Div from "../base/Div";
import FlexRow from "../base/FlexRow";
import Icon from "../base/Icon";
import Timer from "../timer/Timer";
import Indicator from "../base/Indicator";
import IconButton from "../base/IconButton";
import InCallDialPad from "./InCallDialPad";
import TransferCall from "./TransferCall";
import { useCallJobSource } from "./useCallJobSource";



interface IProps {
    call: CallStateSnapshot
    callerId?: string
    jobs: Job[]
    isTech: boolean
    phone: SipPhoneManager
}
export default function ActiveCall(props: IProps) {


    const [transfering, transferingSet] = useState<boolean>(false)
    const [incallDialPadOpen, incallDialPadOpenSet] = useState<boolean>(false)
    const jobSource = useCallJobSource(props.call)


    const [established, establishedSet] = useState<boolean>(false)

    useEffect(() => {
        if (props.call.status == "established" && !established)
            establishedSet(true)
    }, [props.call.status])


    useEffect(() => {

        if (props.call.status == "held") {
            props.phone.unholdCall(props.call.id)
        }

        transferingSet(false)
        incallDialPadOpenSet(false)

    }, [props.call.id])


    return (
        <FlexRow className="mx-2 py-2 h-450px position-relative" column>

            {
                props.call.status == "established" &&
                //true &&
                <div style={{
                    position: "absolute",
                    top: 10,
                    left: 0
                }}>
                    <IconButton icon="dialpad" size={18}
                        className={`${incallDialPadOpen ? 'bg-primary text-white' : ''}`}
                        onClick={() => incallDialPadOpenSet(p => !p)} />
                </div>
            }



            <FlexRow>
                {
                    props.call.status == "established" ?
                        <Timer baseDate={props.call.startedAt} />
                        : props.call.status == "ringing" ?
                            <>
                                Ringing...
                            </>
                            : props.call.status == "establishing" ?
                                <>
                                    Connecting...
                                </>
                                : props.call.status == "held" ?
                                    <>
                                        <Icon icon="pause-circle" type="solid" className="me-1" />
                                        <span>Hold</span>
                                    </>
                                    :
                                    <>Calling...</>
                }
            </FlexRow>

            {
                props.callerId && props.callerId.length > 0 ?
                    <div>
                        <div className="fs-1 text-center">
                            {
                                props.isTech && <Icon icon="user-helmet-safety" className="me-1" />
                            }
                            {props.callerId}
                        </div>
                        <div className="fs-7 text-gray-700 text-center">
                            {props.call.callerId}
                        </div>
                    </div>
                    :
                    <div className="fs-1 text-center">
                        {props.call.callerId}
                    </div>
            }

            {
                jobSource.jobSourceName &&
                <FlexRow justify="center" className="fs-7 text-gray-700 mt-2">
                    <Icon icon="bullhorn" type="solid" className="me-2" />
                    {jobSource.jobSourceName}
                </FlexRow>
            }


            {
                incallDialPadOpen ? <InCallDialPad call={props.call} phone={props.phone} />
                    :
                    <>
                        {
                            transfering ? <TransferCall call={props.call} phone={props.phone} onTransfered={() => transferingSet(false)} />
                                :
                                <div className="h-250px w-100 scroll-y my-2">

                                    {
                                        props.phone.getState().calls
                                            .filter(c => c.id != props.call.id && c.status != "ended" && c.status != "failed")
                                            .map(c => (
                                                <FlexRow key={`active-call-other-call-${c.id}`} className="w-100 border-bottom py-3"
                                                    onClick={async e => {
                                                        e?.preventDefault()
                                                    }}>

                                                    {
                                                        c.status == "ringing" ?
                                                            <div className="me-2">
                                                                <Icon icon="phone-rotary" shake />
                                                            </div>
                                                            : c.status == "held" ?
                                                                <div className="me-2">
                                                                    <Icon icon="pause-circle" />
                                                                </div>
                                                                : <></>
                                                    }

                                                    <div>
                                                        {c.callerId}
                                                    </div>
                                                    {
                                                        c.status == "ringing" ?
                                                            <FlexRow className="ms-auto">

                                                                <Div title="Reject" className="me-5"
                                                                    onClick={async () => {
                                                                        await props.phone.hangup(c.id)
                                                                    }}>
                                                                    <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={26} />
                                                                </Div>

                                                                <Div title="Answer"
                                                                    onClick={async () => {
                                                                        await props.phone.holdCurrentAndAnswer(c.lineId, c.id)
                                                                    }}>
                                                                    <Icon icon="circle-phone" type="solid" className="text-success" size={26} />
                                                                </Div>

                                                            </FlexRow>
                                                            : c.status == "establishing" ?
                                                                <div className="ms-auto">
                                                                    <Indicator text="connecting..." />
                                                                </div>
                                                                :
                                                                <FlexRow className="ms-auto">
                                                                    <button className="btn btn-sm btn-primary me-2" disabled={c.status != "held"}
                                                                        onClick={async () => {
                                                                            await props.phone.holdCall(props.call.id)
                                                                            await props.phone.unholdCall(c.id)
                                                                        }}>
                                                                        <Icon icon="phone-arrow-down-left" className="me-1" />
                                                                        Switch
                                                                    </button>
                                                                </FlexRow>
                                                    }

                                                </FlexRow>
                                            ))
                                    }

                                    {
                                        props.jobs.map(job =>
                                            <FlexRow key={`active-call-job-${job.id}`} className="w-100 border-bottom py-3"
                                                onClick={e => {
                                                    e?.preventDefault()
                                                    openJobQuickView(job.id)
                                                }}>

                                                <div className="me-10">
                                                    <div className="fs-7 mt-1">
                                                        #{job.jobId}
                                                    </div>
                                                    <FlexRow>
                                                        <Icon icon="circle" type="solid" color={job.jobStatus?.color} size={12} />
                                                        <span className="fs-8 ms-1 limited-text" style={{ width: 80 }}>
                                                            {job.jobStatus?.name}
                                                        </span>
                                                    </FlexRow>
                                                </div>

                                                <div>
                                                    <FlexRow>
                                                        <Icon icon="wrench" className="me-1 text-gray-800 fs-8" />
                                                        <span className="text-gray-800 fs-8">
                                                            {job.jobType}
                                                        </span>
                                                    </FlexRow>
                                                    <FlexRow>
                                                        <Icon icon="bullhorn" className="me-1 text-gray-800 fs-8" />
                                                        <span className="text-gray-800 fs-8">
                                                            {job.jobSource}
                                                        </span>
                                                    </FlexRow>
                                                </div>

                                                <div className="ms-auto me-2">
                                                    <a href="#" onClick={e => e.preventDefault()}>
                                                        <Icon icon="chevron-circle-right" type="solid" doutone size={24} />
                                                    </a>
                                                </div>

                                            </FlexRow>
                                        )
                                    }



                                </div>
                        }


                        {
                            props.call.direction == "incoming" && props.call.status == "ringing" ?
                                <FlexRow className="w-100" justify="center">
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            await props.phone.hangup(props.call.id)
                                        }}>
                                        <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={50} />
                                        <div className="fs-5">
                                            Reject
                                        </div>
                                    </Div>
                                    <Div className="dialpad-number">
                                    </Div>
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            await props.phone.answerCall(props.call.id)
                                        }}>
                                        <Icon icon="circle-phone" type="solid" className="text-success" size={50} />
                                        <div className="fs-5">
                                            Answer
                                        </div>
                                    </Div>
                                </FlexRow>
                                :
                                <FlexRow className="w-100" justify="center">
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            if (!established) return;
                                            transferingSet(t => !t)
                                        }}>
                                        <Icon icon="circle-arrow-right" type="solid" className={`${!established ? "text-gray-400" : transfering ? "text-primary" : "text-gray-600"}`} size={40} />
                                        <div className="fs-7 fw-normal">
                                            Transfer
                                        </div>
                                    </Div>
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            if (!established) return;
                                            if (props.call.isHeld)
                                                await props.phone.unholdCall(props.call.id)
                                            else
                                                await props.phone.holdCall(props.call.id)
                                        }}>
                                        <Icon icon={`${(props.call.isHeld ? "play-circle" : "pause-circle")}`} type="solid" className={`${!established ? "text-gray-400" : props.call.isHeld ? "text-primary" : "text-gray-600"}`} size={40} />
                                        <div className="fs-7 fw-normal">
                                            {props.call.isHeld ? "Resume" : "Hold"}
                                        </div>
                                    </Div>
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            await props.phone.hangup(props.call.id)
                                        }}>
                                        <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={40} />
                                        <div className="fs-7 fw-normal">
                                            End
                                        </div>
                                    </Div>
                                    <Div className="dialpad-number"
                                        onClick={async () => {
                                            if (props.call.isMuted)
                                                await props.phone.unmuteCall(props.call.id)
                                            else
                                                await props.phone.muteCall(props.call.id)
                                        }}>
                                        <Icon icon="microphone-circle" type="solid" className={`${props.call.isMuted ? "text-danger" : "text-gray-600"}`} size={40} />
                                        <div className="fs-7 fw-normal">
                                            {props.call.isMuted ? "Unmute" : "Mute"}
                                        </div>
                                    </Div>
                                    <Div className="dialpad-number"
                                        onClick={() => {
                                            closeBrowserPhone()
                                            createJob(undefined, undefined, {
                                                phone: props.call.callerId,
                                                jobSourceId: jobSource.jobSourceId
                                            })
                                        }}>
                                        <Icon icon="circle-plus" type="solid" className="text-gray-600" size={40} />
                                        <div className="fs-7 fw-normal">
                                            Add Job
                                        </div>
                                    </Div>
                                </FlexRow>
                        }

                    </>
            }





        </FlexRow>
    )
}